<template>
	<v-menu
		v-model="menu"
		:close-on-content-click="false"
		offset-y
		:nudge-width="250"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn v-bind="attrs" v-on="on" small>
				<v-icon left>add</v-icon>
				{{ $t('button.new-job') }}
			</v-btn>
		</template>

		<v-card>
			<v-card-text style="padding: 0">
				<ValidationObserver
					ref="attach_new_job_form"
					tag="form"
					@submit="handleAdd"
					id="attach_new_job_form"
				>
					<v-container fluid>
						<v-row>
							<v-col>
								<JobPicker
									v-model="job_id"
									:jobs="jobs"
									:label="`${$t('label.job')}*`"
									rules="required"
									hide-inactive-teams
									hide-inactive-departments
									hide-draft-jobs
									hide-pending-jobs
									hide-archived-jobs
									hide-closed-jobs
									dense
								></JobPicker>
							</v-col>
						</v-row>
					</v-container>
				</ValidationObserver>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click="menu = false">
					{{ $t('button.cancel') }}
				</v-btn>
				<v-btn color="primary" @click="handleAdd">
					{{ $t('button.add') }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-menu>
</template>

<script>
import { mapState } from 'vuex';
import { ValidationObserver } from 'vee-validate';
import JobPicker from '@/components/shared/jobPicker/JobPicker';

export default {
	name: 'NewJobMenu',
	components: {
		ValidationObserver,
		JobPicker,
	},
	props: {
		candidateId: {
			type: Number,
			required: false,
		},
	},
	computed: {
		...mapState({
			jobs: state => state.jobs.items,
		}),
	},
	data() {
		return {
			menu: false,
			job_id: null,
		};
	},
	methods: {
		async handleAdd(evt) {
			if (evt) {
				evt.preventDefault();
			}
			const isValid = await this.$refs.attach_new_job_form.validate();
			if (isValid) {
				const { job_id, candidateId } = this;
				await this.$store.dispatch('candidates/post_applications', {
					id: candidateId,
					job_id,
				});
				this.menu = false;
				this.$store.commit('candidates/setItemNeedsToRefresh');
				this.$store.commit('candidates/setItemsNeedToRefresh');
			}
		},
	},
};
</script>
